import styled from 'styled-components/macro';

export default styled.div`
  display: flex;
  justify-content: center;
  box-shadow: inset 0 15px 15px -15px rgba(0, 0, 0, 0.2);
  background-color: rgba(${p => p.theme.color.primary}, 1);
  color: rgba(${p => p.theme.color.light}, 1);
  line-height: 1.5rem;
  min-height: 300px;
  padding-bottom: 50px;

  a {
    color: rgba(${p => p.theme.color.light}, 1);
  }
`;
